import { FC } from "react";
import { TextBox } from "./TextArea.styled";

import { useTranslation } from "../../../hooks/useTranslation";

export interface TextDataInfo {
  value?: string;
}

type Props = {
  value: TextDataInfo;
  onChange: (value: string) => void;
};

export const TextArea: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <TextBox
      value={value.value}
      onChange={({ target }) => onChange(target.value)}
      placeholder={t("textAreaPlaceholder")}
      rows={3}
    ></TextBox>
  );
};
